import DwFormField from '@ui/formfield/DwFormField';
import { BAA } from '@utils/constants';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const BookAnAppointmentReasonMessage = (props) => {
    const { t } = useTranslation();
    const { formdef, values } = props;
    const [placeholderOverride, setPlaceholderOverride] = useState();
    const messagesReason = {
        '552250000': t('button.discovercollectionreason'),
        '552250001': t('button.specialoccasionreason'),
        '552250002': t('button.skiwearreason'),
        '552250003': t('button.aftersalessupportreason'),
        '552250004': t('button.personalizationroomreason'),
    };
    useEffect(() => {
        if (values.reason != null) {
            const reasonSelected = values.reason.toString();
            const printMsgReason = messagesReason[reasonSelected];
            setPlaceholderOverride(printMsgReason);
        }
        else {
            // Resets the message when returning to the default value
            setPlaceholderOverride(null);
        }
    }, [values.reason]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-12" },
                React.createElement(DwFormField, { def: formdef, name: "messageforstore", type: "textarea", overridePlaceholder: values.reason == BAA.REASONS.PERSONALIZATION ? t('mbm.baamessage') : placeholderOverride ? placeholderOverride : undefined, disabled: props.disabled })))));
};
export default BookAnAppointmentReasonMessage;
